module.exports = __webpack_public_path__ + "static/img/pay_error_icon@3x.585087f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pay_error_icon@3x.png
// module id = zbMq
// module chunks = 1